export function track(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  if (window.location.pathname.startsWith("/admin")) return;
  window.gtag("event", name, params);
}

export const gameParams = (g, category) => ({
  game_name: g?.title,
  game_slug: g?.slug,
  game_category: category?.name || g?.category,
});
